import { CommunicationEndpointTypeNameSet } from './CommunicationEndpoints.js';
import { PersonDescriptionTypeNameSet } from './PersonDescriptions.js';
// #### Recipes ####
export const ProfileRecipe = {
    $type$: 'Recipe',
    name: 'Profile',
    rule: [
        {
            itemprop: 'personId',
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['Person']) },
            isId: true
        },
        {
            itemprop: 'owner',
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['Person']) },
            isId: true
        },
        {
            itemprop: 'nickname',
            itemtype: { type: 'string' },
            optional: true
        },
        {
            itemprop: 'category',
            itemtype: { type: 'string' },
            optional: true
        },
        {
            itemprop: 'communicationEndpoint',
            itemtype: {
                type: 'bag',
                item: { type: 'referenceToObj', allowedTypes: CommunicationEndpointTypeNameSet }
            }
        },
        {
            itemprop: 'personDescription',
            itemtype: {
                type: 'bag',
                item: { type: 'referenceToObj', allowedTypes: PersonDescriptionTypeNameSet }
            }
        }
    ]
};
// #### Reverse maps ####
export const ProfileReverseMaps = [
    ['Profile', new Set(['communicationEndpoint', 'personDescription'])]
];
export const ProfileReverseMapsForIdObjects = [
    ['Profile', new Set(['owner', 'personId'])]
];
export default [ProfileRecipe];
//# sourceMappingURL=Profile.js.map